/**
 * Auth Messages Constants
 * Centralized auth title and description pairs for different flows
 */
export const AUTH_MESSAGES = {
    DEFAULT: {
        title: 'Log in or sign up',
        description: 'Log in or sign up for a personalized apartment search and rental experience.',
    },
    REVIEW_CREATE: {
        title: 'Log in or sign up to submit review',
        description: 'Log in or sign up to submit your review. Your email will never be shared or associated with your review. We require this to verify that you are not a bot. ',
    },
    CHAT_MESSAGE: {
        title: 'Log in or sign up to schedule a tour',
        description: 'Log in or sign up to schedule a tour for this apartment. Creating an account on Openigloo ensures a personalized apartment search and rental experience.',
    },
    VIDEO_TOUR: {
        title: 'Log in or sign up to view video tour',
        description: 'Log in or sign up to view a video tour of this apartment.',
    },
    APPLICATION_PROFILE: {
        title: 'Log in or sign up to apply',
        description: 'Log in or sign up to start, save, and submit your rental applications. Creating an account on Openigloo ensures a personalized apartment search and rental experience.',
    },
    SAMPLE_REPORT: {
        title: 'Log in or sign up to view sample report',
        description: 'Log in or sign up to view sample report. You can then purchase access with your Openigloo account.',
    },
    PERSONALIZATION: {
        title: 'Log in or sign up for personalization',
        description: 'Log in or sign up to personalize your apartment search.',
    },
};
